<template>
  <button role="button" @click.prevent="getNaverToken">
    <slot>
      <sns-logo-circle sns-name="naver" :width="60" :height="60" />
    </slot>
    <span class="a11y-hidden">네이버로 로그인</span>
    <div v-show="false" id="naverIdLogin"></div>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { onMounted, onUnmounted, ref } from 'vue'
  import constant from '@/common/resources/constant'

  const emit = defineEmits(['success', 'fail'])

  const naverOAuth = ref()

  const getNaverToken = () => {
    const loginElement = document.getElementById('naverIdLogin_loginButton')
    if (loginElement) {
      loginElement.setAttribute('href', 'javascript:;')
      // eslint-disable-next-line
      if (/* @cc_on ! @ */ false) {
        // eslint-disable-next-line
        loginElement.fireEvent('onclick')
      } else {
        // Others
        let event = document.createEvent('MouseEvents')
        event.initEvent('click', false, true)
        loginElement.dispatchEvent(event)
      }
    }
  }

  const loginSuccessCallback = (event) => {
    if (
      event.origin === location.origin &&
      event.data.eventMessage === 'naverLogin'
    ) {
      const tokenReceiver = event?.data?.tokenReceiver
      if (tokenReceiver) {
        const result = JSON.parse(tokenReceiver)
        if (result.success) {
          const token = decodeURIComponent(result.access_token)
          if (token) {
            emit('success', { token })
          }
        } else {
          emit('fail')
        }
      }
    }
  }

  const init = async () => {
    let loadingInterval = await setInterval(() => {
      if (window.naver) {
        // window.naver 로드 완료 되면 Interval 취소
        clearInterval(loadingInterval)
        // LoginWithNaverId 선언
        naverOAuth.value = new naver.LoginWithNaverId({
          clientId: 'IMRF4m29ielhnUTZYGHL', // 개발자센터에 등록한 ClientID
          // 개발자센터에 등록한 callback Url
          callbackUrl:
            constant.URL_PROTOCOL_WITH_DOMAIN + '/member/login_naver.html',
          isPopup: true, // 팝업을 통한 연동처리 여부
          callbackHandle: true, // callback 페이지 핸들링 여부
          loginButton: { color: 'green', type: 1, height: 60 }, // 로그인 버튼의 타입을 지정
        })
        // 설정정보를 초기화하고 연동 준비
        naverOAuth.value.init()
      }
    }, 200)
  }

  onMounted(async () => {
    window.addEventListener('message', loginSuccessCallback)
    await init()
  })

  onUnmounted(() => {
    window.removeEventListener('message', loginSuccessCallback)
  })
</script>
